import {isEmpty} from 'lodash';

export const validate = (values) => {
  const {communityCollegeInfo, bio, currentInstitution} = values;
  const {transferSemester, transferYear} = communityCollegeInfo;
  const errors = {};

  if (communityCollegeInfo && !transferYear) {
    errors.communityCollegeInfo = {
      transferYear: 'Transfer year is required.',
    };
  }

  if (communityCollegeInfo && !transferSemester) {
    errors.communityCollegeInfo = {
      transferSemester: 'Transfer semester is required.',
    };
  }

  if (communityCollegeInfo && !communityCollegeInfo.intendedMajor) {
    errors.communityCollegeInfo = {
      intendedMajor: 'Intended major is required.',
    };
  }

  if (bio && bio.length >= 140) {
    errors.bio = 'Bio must be less than 140 characters.';
  }

  if (
    currentInstitution &&
    currentInstitution.campuses &&
    currentInstitution.campuses.length > 0 &&
    isEmpty(currentInstitution.campus)
  ) {
    errors.currentInstitution = {
      campus: 'Please select where you take most of your classes to save your changes.',
    };
  }

  if (!currentInstitution?.name) {
    errors.currentInstitution = {
      name: 'College is required.',
    };
  }

  return errors;
};
